import styled from "styled-components";
import { Container } from "../../styles/Container";

export const Wrapper = styled.div`
  margin: 5rem auto;

  ${Container}
`;

export const Content = styled.div`
  width: 100%;
  padding: 1rem 0;

  display: grid;
  gap: 3rem;

  h1 {
    text-align: center;
    font-size: 72px;
  }
`;
